import {Environment, useInstanceInfo} from '@deliveryhero/vendor-web-core';

const PRODUCTION_TOKEN = 'ab250454-fa8a-4c80-a3b9-a151250c7fe4';
const STAGING_TOKEN = 'b77239d9-3abc-4efd-8a64-2d3fc5ad0c2d';

export const INSTANCE_CONFIG_MAP: Record<Environment, string> = {
  local: STAGING_TOKEN,
  stg01: STAGING_TOKEN,
  stg02: STAGING_TOKEN,
  stg03: STAGING_TOKEN,
  prd01: PRODUCTION_TOKEN,
  prd04: PRODUCTION_TOKEN,
};

export const useFwFToken = (): string => {
  const {environment} = useInstanceInfo();
  return INSTANCE_CONFIG_MAP[environment];
};
